import React from 'react'
import { observer } from 'mobx-react'
import * as defaultConst from '../../../constants/default_constants'
import * as linkConst from '../../../constants/link_constants'
import I18nInput from '../../input/i18n'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import { Button, Modal } from 'react-bootstrap'
import { Helmet } from 'react-helmet'

const EnumForm = observer(({ store, tablang }) => {
  const record = store.cv.record
  const errors = store.cv.errors
  const adding = store.cv.adding
  const valueEditDisabled = !adding
  const updateField = store.cv.updateData.bind(store.cv)
  const rootChildren = store.cv.root.children

  const eVal = (store.cv.editedParent && rootChildren.find(o => o.value === store.cv.editedParent)
    ? rootChildren.find(o => o.value === store.cv.editedParent).text
    : '') ||
    (record && record.get('value') && rootChildren.find(o => o.value === record.get('value'))
      ? rootChildren.find(o => o.value === record.get('value')).text
      : '')

  return store.cv.showForm ? (
    <Modal show backdrop='static' onHide={() => store.cv.cancelEdit()}>
      <Helmet title={store.__(linkConst.LINK_ENUMS_TITLE).concat(defaultConst.HTML_DIVIDER) + (record.get('value')
        ? (record.has('value') ? record.get('value') : store.__(defaultConst.TITLE_EDIT))
        : (eVal ? store.__(defaultConst.TITLE_ADD) : store.__(defaultConst.TITLE_CREATE))
      )} />
      <Modal.Header closeButton>
        <Modal.Title>{store.__(linkConst.LINK_ENUMS_TITLE).concat(defaultConst.TITLE_DIVIDER) + (record.get('value')
          ? store.__(defaultConst.TITLE_EDIT) + ': ' + eVal
          : (eVal ? store.__(defaultConst.TITLE_ADD) + ': ' + eVal : store.__(defaultConst.TITLE_CREATE))
        )}
        </Modal.Title>
      </Modal.Header>
      <div className={errors.size > 0 ? 'enum-modal has-error' : 'enum-modal'}>
        <Modal.Body>
          <div className='row'><div className='col-sm-12 col-md-12 col-lg-6'>
            <TextInput label={store.__('ID')} disabled={valueEditDisabled} attr={'value'}
              record={record} onChange={updateField} errors={errors} />
          </div></div>
          {tablang &&
          <p><Button bsSize='small' bsStyle='info' onClick={() => store.cv.copyLang(record, tablang)}>
            <i className='glyphicon glyphicon-duplicate' />&nbsp; {store.__('Copy the EN title into ') + tablang.toUpperCase()}
          </Button></p>
          }
          <I18nInput
            label={store.__('Title')}
            attrs={record.get('transls')}
            optionsMap={store.options}
            name='transls'
            onChange={store.cv.handleChange}
            onAdd={store.cv.handleAdd}
            onRemove={store.cv.handleRemove}
            store={store}
            tablang={tablang}
            errors={errors} />
          {errors.size > 0 &&
            <span className='help-block'>
              {errors.get('_global')}
            </span>
          }
        </Modal.Body>
      </div>
      <Modal.Footer>
        <div className='btn-group' role='group'>
          <button
            type='button'
            className='btn btn-primary'
            disabled={errors.size > 0}
            onClick={() => store.cv.saveEnum()}>
            <span className='glyphicon glyphicon-save' />&nbsp;
            {store.__(defaultConst.TITLE_SUBMIT)}</button>
          <button type='button' className='btn btn-default' onClick={() => store.cv.cancelEdit()}>
            <span className='glyphicon glyphicon-remove' />&nbsp;
            {store.__(defaultConst.TITLE_CANCEL)}</button>
        </div>
      </Modal.Footer>
    </Modal>
  ) : null
})
export default EnumForm
